import React from "react";

export default function KazemLogo({ className = "", light = false, size = "md" }) {
    const navy = light ? "#FFFFFF" : "#102744";
    const h = size === "lg" ? 64 : 42;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 320" role="img" aria-label="KAZEM LOGISTICS"
            height={h} width={h * 3.75} className={className} data-testid="kazem-logo">
            <g>
                <path fill="#F36B21" d="M35 30 H97 V92 L35 154 Z" />
                <path fill={navy} d="M35 178 L197 26 H273 L111 190 V277 H35 Z" />
                <path fill="#F36B21" d="M157 180 L207 142 L274 277 H198 Z" />
            </g>
            <g>
                <text x="330" y="151" fill={navy} fontFamily="Montserrat, Arial, sans-serif" fontSize="112" fontWeight="800" letterSpacing="1">KAZEM</text>
                <text x="334" y="225" fill="#F36B21" fontFamily="Montserrat, Arial, sans-serif" fontSize="55" fontWeight="700" letterSpacing="13">LOGISTICS</text>
            </g>
        </svg>
    );
}
